import KunLoading10 from './src/index'

KunLoading10.install = function (Vue) {
	Vue.component(KunLoading10.name, KunLoading10);
}

export default KunLoading10;
